import { compose, withProps } from 'react-recompose';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';
import HelpNavMenuComponent from './help-nav-menu';

const contactSupportProps = withProps(({ heAccount }) => ({
  contactSupportEmail: `mailto:${heAccount.isFreemium ? process.env.COUNSELOR_COMMUNITY_EMAIL : process.env.SUPPORT_EMAIL}`,
}));

const HelpNavMenuWithProps = compose(
  withHEAccountSubscriptions,
  contactSupportProps,
)(HelpNavMenuComponent);

export default HelpNavMenuWithProps;
